<template>
  <div v-cloak>
    <div class="vx-card">
      <div class="vx-card__body card-body p-6">
        <div class="vx-col w-full vx-row mx-0 mb-2">
          <div class="lg:w-1/4 sm:w-1/2">
            <vs-input
              class="inputx"
              v-model="transactionId"
              name="transactionId"
              :label="$t('SearchInventoryTransactionId')"
            />
          </div>
          <vs-button
            class="mt-6 mx-4"
            color="success"
            type="gradient"
            icon-pack="feather"
            icon="icon-search"
            @click.prevent="getDetailsTransactions()"
          ></vs-button>
        </div>
        <div v-if="isShowTable">
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="vx-card mb-4">
                <div
                  class="vx-card__collapsible-content vs-con-loading__container"
                >
                  <div class="vx-card__body custom-tbl" id="draft-order-tbl">
                    <vs-table :data="allSerialsList" ref="table">
                      <template slot="thead">
                        <vs-th style="width: 10%">#</vs-th>
                        <vs-th style="width: 40%">{{ $t("StockName") }}</vs-th>
                        <vs-th style="width: 20%">{{ $t("ItemCode") }}</vs-th>
                        <vs-th style="width: 20%">
                          <vs-checkbox
                            @click="editAllSelectedSerialsList($event)"
                            :checked="isSelectCheckboxSelectAll"
                            class="mx-4"
                          >
                          </vs-checkbox>
                          {{ $t("Action") }}
                        </vs-th>
                      </template>
                      <template slot-scope="{ data }">
                        <vs-tr
                          v-for="(tr, indextr) in data"
                          :data="tr"
                          :key="indextr"
                        >
                          <vs-td>
                            {{ indextr + 1 }}
                          </vs-td>
                          <vs-td>
                            {{ tr.name }}
                          </vs-td>
                          <vs-td>
                            {{ tr.itemCode }}
                          </vs-td>
                          <vs-td>
                            <div
                              v-if="tr.serial"
                              style="margin-right:20%"
                              class="flex"
                            >
                              <vs-checkbox
                                @click="
                                  editListOfSelectedSerials(
                                    data[indextr],
                                    indextr,
                                    $event
                                  )
                                "
                                v-model="checkboxSerialsList[indextr]"
                                class="mx-4"
                              >
                              </vs-checkbox>
                              <span class="m-4">
                                {{ tr.serial }}
                              </span>
                            </div>
                            <div class="w-full" v-else>
                              <label class="vs-select--label">{{
                                $t("DraftOrderId")
                              }}</label>
                              <vs-input name="ItemCount" v-model="tr.count" />
                            </div>
                          </vs-td>
                        </vs-tr>
                      </template>
                    </vs-table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="vx-card">
            <div
              class="vx-row mb-6 p-4 vx-card__body"
              style="padding:2% !important"
            >
              <div class="vx-col sm:w-1/4 w-full mt-1 p-0">
                <label class="vs-select--label">{{
                  $t("WarehouseName")
                }}</label>
                <v-select
                  label="name"
                  name="warehouse"
                  :options="allWarehouses"
                  v-model="modelForShow.storeId"
                  v-validate="{ required: true }"
                  :reduce="x => x.id"
                  @input="selectWarehouse"
                  ref="warehouseSelect"
                  :clearable="true"
                  dir="rtl"
                >
                </v-select>
                <span
                  class="text-danger text-sm mt-3"
                  v-show="errors.has('warehouse')"
                  >{{ errors.first("warehouse") }}</span
                >
              </div>
              <div class="vx-col sm:w-1/4 w-full mt-1 px-2">
                <label class="vs-select--label">{{ $t("ShelveName") }}</label>
                <v-select
                  label="name"
                  name="shelve"
                  :options="shelves"
                  v-model="modelForShow.shelveId"
                  :reduce="x => x.id"
                  v-validate="{ required: true }"
                  ref="shelveSelect"
                  @input="selectShelve"
                  dir="rtl"
                >
                </v-select>
                <span
                  class="text-danger text-sm mt-3"
                  v-show="errors.has('shelve')"
                  >{{ errors.first("shelve") }}</span
                >
              </div>
              <div class="vx-col sm:w-1/3 w-full mt-1 px-0 mx-0">
                <vs-input
                  v-model="modelForShow.description"
                  :label="$t('Description')"
                />
                <span
                  class="text-danger text-sm mt-3"
                  v-show="errors.has('Description')"
                  >{{ errors.first("Description") }}</span
                >
              </div>
              <div class="vx-col sm:w-1/6 w-full m-0 px-0 pt-6">
                <vs-button
                  type="filled"
                  class="float-right"
                  @click.prevent="submitForm()"
                  >{{ $t("ReturnOrders") }}</vs-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import { mapGetters, mapActions } from "vuex";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import vSelect from "vue-select";
import { Validator } from "vee-validate";
import * as moment from "jalali-moment";

const dict = {
  custom: {
    warehouse: {
      required: "لطفا نام انبار را انتخاب نمایید."
    },
    shelve: {
      required: "لطفا نام قفسه را انتخاب نمایید."
    }
  }
};
Validator.localize("fa", dict);
export default {
  name: "",
  components: {
    "v-select": vSelect
  },
  data() {
    return {
      transactionId: null,
      isShowTable: false,
      checkboxSerialsList: [],
      allSerialsList: [],
      isSelectCheckboxSelectAll: false,
      model: {},
      modelForShow: {},
      selectedSerials: []
    };
  },
  computed: {
    ...mapGetters({
      allWarehouses: "warehouse/list"
    }),

    shelves() {
      var warehouse = this.$store.getters["warehouse/list"].find(
        obj => obj.id == this.modelForShow.storeId
      );
      return warehouse ? warehouse.shelveQueries : [];
    }
  },
  methods: {
    ...mapActions({
      CheckOutTransactions: "checkOutTransactions/CheckOutTransactions",
      CreateCheckInForReturnCheckOut:
        "checkInTransactions/CreateCheckInForReturnCheckOut",
      fetchWarehouses: "warehouse/fetchListWithNOTakeSkip"
      // readWarehousesWithoutTakeSkip: "warehouse/readWarehousesWithoutTakeSkip"
    }),
    editListOfSelectedSerials(val, indextr, event = true) {
      if (event.target.checked) {
        this.selectedSerials.push(val);
        this.checkboxSerialsList[indextr] = true;
      } else {
        let index = this.selectedSerials.indexOf(val);
        this.selectedSerials.splice(index, 1);
        this.checkboxSerialsList[indextr] = false;
      }
    },
    editAllSelectedSerialsList(event) {
      this.selectedSerials = [];
      if (event.target.checked) {
        for (let index = 0; index < this.allSerialsList.length; index++) {
          this.selectedSerials.push(this.allSerialsList[index]);
          this.checkboxSerialsList[index] = true;
        }
      } else {
        for (let index = 0; index < this.allSerialsList.length; index++) {
          this.checkboxSerialsList[index] = false;
        }
      }
    },
    getDetailsTransactions() {
      if (this.transactionId) {
        this.CheckOutTransactions(this.transactionId).then(r => {
          this.modelForShow = r;
          this.allSerialsList = this.modelForShow.inventoryTransactionItemCommands;
          for (let index = 0; index < this.allSerialsList.length; index++) {
            this.checkboxSerialsList[index] = false;
          }
          this.buildCurrentTime();
          this.fetchWarehouses();
          // this.readWarehousesWithoutTakeSkip();
          this.isShowTable = true;
        });
      }
    },
    buildFinallyModel() {
      this.model = {
        checkOutId: this.modelForShow.id,
        description: this.modelForShow.description,
        cumulativeCheckInForReturnCheckOutItemsCommand: []
      };
      this.selectedSerials.forEach(elem => {
        this.model.cumulativeCheckInForReturnCheckOutItemsCommand.push({
          cottageNumber: elem.cottageNumber,
          shipmentNumber: elem.shipmentNumber,
          storeId: this.modelForShow.storeId,
          itemCode: elem.itemCode,
          registerClock: this.modelForShow.registerClock,
          serial: elem.serial,
          identificationCode: elem.identificationCode,
          trackingId: elem.trackingId,
          passagePermit: elem.passagePermit,
          name: elem.name,
          shelveId: this.modelForShow.shelveId,
          shelveName: this.modelForShow.shelveName,
          count: elem.serial ? null : elem.count
        });
      });
    },
    buildCurrentTime() {
      let todayJalali = moment()
        .locale("fa")
        .format("YYYY-M-D hh:mm:ss");
      this.modelForShow.registerClock = todayJalali;
    },
    onfinish(selectedSerials) {
      this.modelForShow.serials = selectedSerials;
    },
    selectShelve() {
      if (this.modelForShow.shelveId) {
        this.modelForShow.shelveName = this.shelves.filter(
          x => x.id == this.modelForShow.shelveId
        )[0].name;
      } else {
        this.modelForShow.shelveName = "";
      }
    },
    selectWarehouse() {
      this.$refs.shelveSelect.clearSelection();
      this.modelForShow.shelveName = "";
    },

    submitForm() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.$swal({
            title: "آیا از برگشت این رسید اطمینان دارید؟",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "بلی",
            cancelButtonText: "خیر"
          }).then(result => {
            if (result.value) {
              this.buildFinallyModel();
              this.CreateCheckInForReturnCheckOut(this.model).then(() => {
                setTimeout(() => {
                  this.$router.push("/CheckInTransactions/Index");
                }, 3000);
              });
            }
          });
        }
      });
    }
  },
  watch: {
    selectedSerials() {
      if (this.selectedSerials.length == this.allSerialsList.length) {
        this.isSelectCheckboxSelectAll = true;
      } else {
        this.isSelectCheckboxSelectAll = false;
      }
    }
  }
};
</script>
